import TimelineOutlined from "@mui/icons-material/TimelineOutlined";
import HelpOutlineOutlined from "@mui/icons-material/HelpOutlineOutlined";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import PaymentOutlined from "@mui/icons-material/PaymentOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import PersonOutlined from "@mui/icons-material/PersonOutlined";
import LocalShippingOutlined from "@mui/icons-material/LocalShippingOutlined";
import ShoppingCartOutlined from "@mui/icons-material/ShoppingCartOutlined";
import PhoneInTalkOutlined from "@mui/icons-material/PhoneInTalkOutlined";
import NotificationsOutlined from "@mui/icons-material/NotificationsOutlined";

import { useSelector } from "react-redux";

const Sidebarlinks = () => {
  const { isOpen } = useSelector((state) => state.sidebar);

  const listItems = [
    {
      id: 1,
      text: "Dashboard",
      link: "/",
      icon: (
        <TimelineOutlined
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></TimelineOutlined>
      ),
    },
    {
      id: 2,
      text: "Users",
      links: "/users",
      // links2: "/adduser",
      subMenus: [
        // { id: "2a", text: "Add New", link: "/adduser" },
        { id: "2b", text: "View All", link: "/users" },
      ],

      icon: (
        <PersonOutlined
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></PersonOutlined>
      ),
    },
    {
      id: 3,
      text: "Orders",
      links: "/orders",
      subMenus: [{ id: "3a", text: "View All", link: "/orders" }],

      icon: (
        <ShoppingCartOutlined
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></ShoppingCartOutlined>
      ),
    },
    {
      id: 4,
      text: "Drivers",
      links: "/drivers",
      links2: "/adddriver",
      subMenus: [
        { id: "4a", text: "Add New", link: "/adddriver" },
        { id: "4b", text: "View All", link: "/drivers" },
      ],

      icon: (
        <LocalShippingOutlined
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></LocalShippingOutlined>
      ),
    },
    {
      id: 5,
      text: "Delivery Modes",
      links: "/deliverymodes",
      links2: "/adddeliverymodes",
      subMenus: [
        { id: "5a", text: "Add New", link: "/adddeliverymodes" },
        { id: "5b", text: "View All", link: "/deliverymodes" },
      ],

      icon: (
        <LocalShippingOutlined
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></LocalShippingOutlined>
      ),
    },
    {
      id: 6,
      text: "Transactions",
      links: "/transactions",
      subMenus: [{ id: "6a", text: "View All", link: "/transactions" }],

      icon: (
        <PaidOutlinedIcon
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></PaidOutlinedIcon>
      ),
    },
    {
      id: 7,
      text: "Payments",
      links: "/payments",
      links2: "/addpayments",
      subMenus: [
        { id: "7a", text: "Add New", link: "/addpayments" },
        { id: "7b", text: "View All", link: "/payments" },
      ],

      icon: (
        <PaymentOutlined
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></PaymentOutlined>
      ),
    },

    {
      id: 8,
      text: "FAQs",
      links: "/faq",
      links2: "/addfaq",
      subMenus: [
        { id: "8a", text: "Add New", link: "/addfaq" },
        { id: "8b", text: "View All", link: "/faq" },
      ],
      icon: (
        <HelpOutlineOutlined
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></HelpOutlineOutlined>
      ),
    },
    {
      id: 9,
      text: "Notifications",
      links: "/notifications",
      subMenus: [{ id: "9a", text: "View All", link: "/notifications" }],
      icon: (
        <NotificationsOutlined
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></NotificationsOutlined>
      ),
    },
    {
      id: 10,
      text: "Support",
      links: "/support",
      links2: "/addsupport",
      subMenus: [
        { id: "10a", text: "Add", link: "/addsupport" },
        { id: "10b", text: "View All", link: "/support" },
      ],
      icon: (
        <PhoneInTalkOutlined
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></PhoneInTalkOutlined>
      ),
    },
    {
      id: 11,
      text: "Settings",
      links: "/profile",
      links2: "/account",
      subMenus: [
        { id: "11a", text: "Profile", link: "/profile" },
        { id: "11b", text: "Account", link: "/account" },
      ],
      icon: (
        <SettingsOutlined
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></SettingsOutlined>
      ),
    },
  ];

  return listItems;
};

export default Sidebarlinks;
